import { DialogContent, DialogTitle, Stack } from "@mui/material";
import { materialGoodsIssueBusiness } from "api/bussiness/material/material-goods-issue";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { IAddMaterialGoodsIssue } from "mobx-stores/_models/material-inventory/material-goods-issue/material-goods-issue";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { useGoodsIssueItemHandlers } from "../hooks/use-goods-issue-item-handlers";
import { getAddMaterialGoodsIssueSchema } from "./schema";

export const AddMaterialGoodsIssue = observer(() => {
  const {
    materialInventoryManagement: {
      materialGoodsIssueStore: { openNew, getMaterialGoodsIssue, setProp },
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    getArrayItemControl,
    submitHandler,
  } = useForm<IAddMaterialGoodsIssue>(getAddMaterialGoodsIssueSchema(), {
    issueDate: dateTimeToUTCString(dayjs()),
    items: [
      {
        materialId: "",
        amount: 0,
        note: "",
      },
    ],
  });

  const saveHandler = useCallback(
    async (data: IAddMaterialGoodsIssue) => {
      try {
        await materialGoodsIssueBusiness.add(data);
        await getMaterialGoodsIssue();
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getMaterialGoodsIssue, setProp],
  );

  const { itemValueChangedHandler } = useGoodsIssueItemHandlers({
    getBrandControl: (rowIndex: number) =>
      getArrayItemControl("items", rowIndex, "brand"),
  });

  const itemsControl = useMemo(() => {
    return getControl("items").children;
  }, [getControl]);

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm xuất kho</DialogTitle>
      <DialogContent>
        <Stack sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
          {itemsControl && itemsControl.length > 0 && (
            <DynamicFormArray
              children={itemsControl}
              controlSpacing={2}
              onValueChanged={itemValueChangedHandler}
            ></DynamicFormArray>
          )}
        </Stack>
      </DialogContent>
    </DialogForm>
  );
});
